export default __webpack_public_path__ + "static/media/img-video-right.2a8cfd9f.png";